import React from "react";
import cn from "classnames";

import { getDataTestId } from "src/utils";
import { LineProps } from "./types";
import { useContent } from "src/hooks";

import styles from "./style.module.scss";

export const useLine = (props: LineProps) => {
  const content = useContent();

  const getLineProps = React.useCallback(
    () => ({
      className: cn(styles[content], styles[`color-${props.line}`], {
        [styles.even]: props.line % 2 === 0,
      }),
      onClick: props.onClick,
      ...getDataTestId(props.testId || ""),
    }),
    [content, props]
  );

  return { getLineProps };
};
